const validateSubmissionReport = function ({ commit, state }) {
  commit("VALIDATE_SUBMISSION_REPORT");
  return Promise.resolve(state.submissionsReportErrors);
};

export default validateSubmissionReport;
